//
// Collapsible Panel with title an continer rows.
// See https://bootswatch.com/ for card children (rows, columns, etc.)
//
import { useState, useEffect } from 'react'

//
// props:
//   string    title   - header
//   string    level   - one of { primary, secondary, success, warning, danger, info, light, dark }
//   bool      open    - [optional] true to display content (default true)
//
const CardWidget = (props) => {
    const [open, setOpen] = useState(props.hasOwnProperty("open") ? props.open : true);
    const [show_children, setShowChildren] = useState(props.hasOwnProperty("open") ? props.open : true);

    function cardClass() {
        let color = props.level === "light" ? "black" : "white";
        let cc = `card text-${color} bg-${props.level} mb-3`;

        return cc;
    }

    function showChildren() {
        let show;
        if (props.hasOwnProperty("open") && props.open !== open) {
            show = props.open;      // changed in parent, parent wins
            setOpen(show);
            setShowChildren(show);
        } else {
            show = show_children;
        }

        return show;
    }

    function toggleChildren() {
        setShowChildren(!show_children);
    }

    useEffect(() => {
        // cleanup function
        return () => {
        };
    }, [show_children]);

    return (
        <div className={cardClass()}>
            <div className="card-header"  onDoubleClick={toggleChildren}>{props.title}</div>
            <div className="card-body">
                {showChildren() &&
                    <div className="form-group">
                        <div className="container">
                            {props.children}
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

export default CardWidget;